export default "__VITE_ASSET__BUPeH$rl__"